// extracted by mini-css-extract-plugin
module.exports = {"countryCard":"CountryCard_countryCard__1Mc_A","flag":"CountryCard_flag__1AhD4","cardInfo":"CountryCard_cardInfo__3Kuch"};